(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-review-carousel]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const slides = [...root.querySelectorAll('[data-review-slide]')];
      const choices = [...root.querySelectorAll('[data-review-choice]')];
      const status = root.querySelector('[data-review-status]');
      if (!slides.length) return;
      let current = 0;
      let activeAnimations = [];
      let transitionId = 0;
      const reducedMotion = typeof window !== 'undefined' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      function show(index, direction = 0, animate = true) {
        const next = (index + slides.length) % slides.length;
        const previous = current;
        const token = ++transitionId;
        activeAnimations.forEach(animation => animation.cancel());
        activeAnimations = [];
        current = next;
        slides.forEach((slide, i) => {
          slide.hidden = i !== current;
          slide.setAttribute?.('aria-hidden', String(i !== current));
          slide.inert = i !== current;
        });
        choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === current)));
        if (status) status.textContent = `${current + 1} / ${slides.length}`;
        if (!animate || previous === current || reducedMotion?.matches || typeof slides[current].animate !== 'function') return;
        const outgoing = slides[previous];
        const incoming = slides[current];
        const step = direction || (current > previous ? 1 : -1);
        outgoing.hidden = false;
        const options = {duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both'};
        const exit = outgoing.animate([
          {opacity: 1, transform: 'translateX(0)'},
          {opacity: 0, transform: `translateX(${-step * 24}px)`}
        ], options);
        const enter = incoming.animate([
          {opacity: 0, transform: `translateX(${step * 24}px)`},
          {opacity: 1, transform: 'translateX(0)'}
        ], options);
        activeAnimations = [exit, enter];
        Promise.allSettled(activeAnimations.map(animation => animation.finished)).then(() => {
          if (token !== transitionId) return;
          outgoing.hidden = true;
          activeAnimations.forEach(animation => animation.cancel());
          activeAnimations = [];
        });
      }
      root.addEventListener('click', event => {
        if (event.target.closest('[data-review-prev]')) show(current - 1, -1);
        if (event.target.closest('[data-review-next]')) show(current + 1, 1);
        const choice = event.target.closest('[data-review-choice]');
        if (choice) show(Number(choice.dataset.reviewChoice));
      });
      root.addEventListener('keydown', event => {
        if (!event.target.closest('[data-review-choice], [data-review-prev], [data-review-next]')) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowLeft' ? -1 : 1));
        choices[current]?.focus();
      });
      let start;
      const stage = root.querySelector('.cv-review-carousel__stage');
      stage?.addEventListener('touchstart', event => { const touch = event.changedTouches[0]; start = {x:touch.clientX, y:touch.clientY}; }, {passive:true});
      stage?.addEventListener('touchend', event => {
        if (!start || event.target.closest('button')) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        start = null;
      }, {passive:true});
      root.addEventListener('shopify:block:select', event => {
        const index = slides.indexOf(event.target.closest('[data-review-slide]'));
        if (index >= 0) show(index);
      });
      reducedMotion?.addEventListener('change', () => show(current, 0, false));
      show(0, 0, false);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
